import {UsefulLinksItemDefaultBox} from './useful-links-item.default.box';
import {styledByTheme} from '../../../../themes/architecture/styled-by-theme';
import {UsefulLinksItemCasino777Box} from './useful-links-item.casino777.box';
import {UsefulLinksItemCipBox} from './useful-links-item.cip.box';
import {UsefulLinksItemMrGreenBox} from "./useful-links-item.mrgreen.box";

export const UsefulLinksItemBox = styledByTheme(UsefulLinksItemDefaultBox)
                                    .forCasino777(UsefulLinksItemCasino777Box)
                                    .forCip(UsefulLinksItemCipBox)
                                    .forWsopCip(UsefulLinksItemCipBox)
                                    .forCis(UsefulLinksItemCipBox) // TODO: see here!!!!!!
                                    .forMrGreen(UsefulLinksItemMrGreenBox)
                                    .apply();